import { LectureDetails } from '../../../../../api/types/lecturers/details/lecture-details';
import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalCourseStore from '../../../../../stores/global-course-store';

export const updateLectureNameOperation = async (
  programId: number,
  courseId: number,
  lectureId: number,
  lectureName: string,
  setIsLoading: (loading: boolean) => void,
  setData: (lectureDetails: LectureDetails) => void,
) => {
  try {
    setIsLoading(true);
    const res = await appApi.updateLectureName(
      programId,
      courseId,
      lectureId,
      lectureName,
    );
    setData(res.data.body);
    setIsLoading(false);
    const resData: LectureDetails = res.data.body;
    globalCourseStore.fetchCourseDetails(programId!, courseId);
  } catch (e) {
    console.error(
      `updateLectureNameOperation is failed with the programId: ${programId}, courseId: ${courseId}, lectureId: ${lectureId}, lectureName: ${lectureName} with the error: ${e}`,
    );
    setIsLoading(false);
    toast.error('משהו קרה, לא ניתן לטעון את פרטי המפגש...');
  }
};
